<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Acknowledge Backorder?</p>
      </header>
      <section class="modal-card-body">
        <div class="has-text-centered py-lg">
          Are you sure you want to acknowledge this backorder?
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >Acknowledge Backorder</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      saving: false
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/orders/' + this.order.id + '/acknowledge-backorder/?abridged=1'
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.put(this.endpoint).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Backorder Acknowledged!' })
        this.$emit('order:updated')
        this.$parent.close()
      }).catch(error => {
        this.$buefy.toast.open({ type: 'is-danger', message: error.response.data[0] })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: ['order']
}
</script>
